export default __webpack_public_path__ + "static/media/ic-crops-beans.d0dbe4fb.png";